import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-2d2a799e"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "joinUs"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "joinUs-pic"
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "joinUs-pic-part"
}, [/*#__PURE__*/_createElementVNode("span", null, "Join Us"), /*#__PURE__*/_createElementVNode("h5", null, "Join XT to acheive a successful career"), /*#__PURE__*/_createElementVNode("div", {
  class: "joinUs-pic-part-bg"
})])], -1));

const _hoisted_3 = {
  class: "joinUs-content"
};

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "content-title"
}, " Company introduction and corporate culture ", -1));

const _hoisted_5 = {
  class: "content-xtIntroduce"
};
const _hoisted_6 = {
  class: "content-xtIntroduce"
};
const _hoisted_7 = {
  class: "content-xtIntroduce"
};
const _hoisted_8 = {
  class: "joinUs-bottom"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "vacancy"
}, "Vacancies", -1));

const _hoisted_10 = {
  class: "vacancy-detail"
};
const _hoisted_11 = {
  class: "career"
};
const _hoisted_12 = {
  class: "link",
  style: {
    "padding-top": "20px",
    "padding-bottom": "20px"
  }
};
const _hoisted_13 = {
  class: "vacancy-detail"
};
const _hoisted_14 = {
  class: "career"
};
const _hoisted_15 = {
  class: "link"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_vacancy_card = _resolveComponent("vacancy-card");

  const _component_link_card = _resolveComponent("link-card");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, _toDisplayString($data.xtIntroduce1), 1), _createElementVNode("div", _hoisted_6, _toDisplayString($data.xtIntroduce2), 1), _createElementVNode("div", _hoisted_7, _toDisplayString($data.xtIntroduce3), 1)]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_vacancy_card, {
    imgUrl: $data.imgurl2,
    title: $data.title2
  }, null, 8, ["imgUrl", "title"])]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allcontent2, list => {
    return _openBlock(), _createElementBlock("div", {
      class: "link-card",
      key: list.key
    }, [_createElementVNode("div", null, [_createVNode(_component_link_card, {
      url: list.linkUrl,
      detail: list.detail,
      content: list.content,
      jobType: list.jobType
    }, null, 8, ["url", "detail", "content", "jobType"])])]);
  }), 128))])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_vacancy_card, {
    imgUrl: $data.imgurl4,
    title: $data.title4
  }, null, 8, ["imgUrl", "title"])]), _createElementVNode("div", _hoisted_15, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.allcontent4, list => {
    return _openBlock(), _createElementBlock("div", {
      class: "link-card",
      key: list.key
    }, [_createElementVNode("div", null, [_createVNode(_component_link_card, {
      url: list.linkUrl,
      detail: list.detail,
      content: list.content,
      jobType: list.jobType
    }, null, 8, ["url", "detail", "content", "jobType"])])]);
  }), 128))])])])]);
}